import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const BirthdayMonth = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;
	const userData = useSelector(state => state.userData);

	const registerField = () => {
		// For Shopcarts controller, only use global validator
		// For other controllers, use Redux store validator
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator && form_component.required) {
			const fieldName = 'birthday[month]';
			
			try {
				// Check if field already exists and remove it first
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					// Explicitly specify the element selector
					selector: `select[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => { // to be updated after render
		registerField();
	}, [fv, controller, form_component.required, t]);

	// Listen for FormValidation reinitialization
	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t]);

	var months = [];
    if (form_component.date_select_na) {
        months[0] = t('不適用');
    }
    for (let i = 1; i <= 12; ++i) {
        months[i] = i;
    }

	return (
		<div className="d-flex align-items-center">
			<div className="me-3">
				<div className="mb-3 form-group select">
					<select
						className="form-select-sm w-date form-select"
						defaultValue={userData && userData.birthday ? userData.birthday.month : ''}
						name="birthday[month]"
					>
						<option value="">-</option>
						{(() => {
							const components = [];
							
							months.map((month, index) => {
								components.push(
									<option key={`month-${index}`} value={month}>{month}</option>
								);
							});

							return components;
						})()}
					</select>
				</div>
			</div>
			<div className="pb-3">{t('月')}</div>
		</div>
	);
}

export default BirthdayMonth;